import { put } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { transactions as types } from 'types';
import {
    IGetTransactionsFilter,
    OrderPosition,
} from '../../types/entities/transactions';

const transactions = {
    get: async (key, params: IGetTransactionsFilter, nextPage = 1) => {
        const filters = {
            page: String(nextPage),
            fromDate: params.fromDate || '',
            toDate: params.toDate || '',
            status: params.status || '',
            type: params.type || '',
            nexId: params.nexId || '',
            referenceNo: params.referenceNo || '',
            orderBy: params.orderBy || '',
            orderPosition: params.orderAsc
                ? OrderPosition.FORWARD
                : OrderPosition.BACKWARD,
        };
        const queryString = new URLSearchParams(filters).toString();
        const headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        const res = await fetch(
            `${process.env['REACT_APP_SERVER_URL']}/${endpoints[
                EEndpoints.transactionsGet
            ]()}?${queryString}`,
            {
                credentials: 'include',
                headers,
            },
        );
        const response = await res.json();
        return {
            data: response,
            nextPage: nextPage + 1,
        };
    },
    withdrawSet({ params }: { params: types.TSetWithdrawStatusParams }) {
        return put<types.TSetWithdrawStatusParams, null>(
            `${endpoints[EEndpoints.transactionsWithdraw](
                params.transactionId,
            )}`,
            params,
        );
    },
    pulsaSet({ params }: { params: types.TSetPulsaStatusParams }) {
        return put<types.TSetPulsaStatusParams, null>(
            `${endpoints[EEndpoints.transactionsPulsa](params.transactionId)}`,
            params,
        );
    },
    set({ params }: { params: types.TSetTransactionStatusParams }) {
        return put<types.TSetPulsaStatusParams, null>(
            `${endpoints[EEndpoints.transactionsByType](
                params.transactionId,
                params.type,
            )}`,
            params,
        );
    },
};

export default transactions;
